export default "__VITE_ASSET__DaKl75Tv__"